import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import AppIcon from './AppIcon';

const Snackbar = ({ type, message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(), 5000);
    return () => clearTimeout(timer);
  });

  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <AppIcon name="check" className = "h-5" /> ;
      case 'error':
        return <AppIcon name="error-circle" className="h-5"/> ;
      default:
        return;
    }
  }

  return (
    <div className="snackbar__container fixed bottom-0 p-4 flex justify-center w-full">
      <div className={`snackbar__content ${type ?? ''}`}>
        <p className="px-5 py-2 font-bold flex-1 flex items-center gap-2 text-sm leading-tight">
          { renderIcon() }
          <span className="flex-1">{message}</span>
        </p>
        <button
          type="button"
          onClick={() => onClose()}
          className="px-5 h-full font-semibold text-xl relative"
        >
          <AppIcon name="error" className="h-2"/>
        </button>
      </div>
    </div>
  );
};

Snackbar.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['success', 'error']),
  message: PropTypes.string
};

export default Snackbar;